export const SPECIALIST_IDS = {
  GENERAL_DENTIST: 'general-dentist',
  ENDODONTIST: 'endodontist',
  ORAL_MAXILLOFACIAL: 'oral-maxillofacial',
  ORTHODONTIST: 'orthodontist',
  PERIODONTIST: 'periodontist',
  PROSTHODONTIST: 'prosthodontist',
  DONT_KNOW: 'dont-know',
};

export const SPECIALIST_TYPES = [
  {
    dbId: 525,
    id: SPECIALIST_IDS.GENERAL_DENTIST,
    title: 'General Dentist',
    description: 'Cleanings, fillings, crowns, and routine dental care.',
  },
  {
    dbId: 590,
    id: SPECIALIST_IDS.ENDODONTIST,
    title: 'Endodontist',
    prefersReferral: true,
    description: 'Root canals and tooth nerve treatments.',
  },
  {
    dbId: 591,
    id: SPECIALIST_IDS.ORAL_MAXILLOFACIAL,
    title: 'Oral and Maxillofacial Surgeon',
    prefersReferral: true,
    description: 'Surgeries for the mouth, jaw, and face.',
  },
  {
    dbId: 584,
    id: SPECIALIST_IDS.ORTHODONTIST,
    title: 'Orthodontist',
    description: 'Braces and teeth straightening treatments.',
  },
  {
    dbId: 585,
    id: SPECIALIST_IDS.PERIODONTIST,
    title: 'Periodontist',
    description: 'Gum disease treatment and gum care.',
  },
  {
    dbId: 592,
    id: SPECIALIST_IDS.PROSTHODONTIST,
    title: 'Prosthodontist',
    description: 'Replacement of missing teeth.',
  },
  {
    dbId: null,
    id: SPECIALIST_IDS.DONT_KNOW,
    title: 'I don’t know',
    altTitle: 'specialist',
    description: 'Help me choose the right specialist.',
  },
];
